import styled from "styled-components"

import { minWidth } from "utils"

import { Content } from "../styles"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;
  clear: both;
  display: block;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Heading = styled.h3`
  padding-bottom: 0.6rem;
  border-bottom: 0.5rem solid #eee;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: normal;
  color: #b5471f;
`

export const Text = styled(Content)`
  width: 100%;
  margin: 0;
  padding: 2rem 0.5rem;
  border-bottom: 3px solid #eee;
  font-weight: 500;
`
